import { Component, input, OnInit } from '@angular/core';
import { GastrointestinalAssessment } from 'src/app/calvin-emr-shared/models/assessments/gastrointestinal.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';

@Component({
  selector: 'app-gastrointestinal-info',
  templateUrl: './gastrointestinal-info.component.html',
  styleUrls: ['./gastrointestinal-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent],
})
export class GastrointestinalInfoComponent
  extends AssessmentInfoComponent<GastrointestinalAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }

  get isReducedAppetite() {
    return this.data().reducedAppetite ? 'Yes' : 'No';
  }

  get isTubeFeed() {
    return this.data().tubeFeed ? 'Yes' : 'No';
  }
}
